import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import vuetify from "./plugins/vuetify";
import i18n from "./i18n";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import VeeValidate from "vee-validate";
import VueGtag from "vue-gtag";
import LoadScript from "vue-plugin-load-script";
import VueLettering from "@miii/vue-lettering";
import veeValidateOptions from "@/plugins/veeValidate";

// TODO: new GitHub Action file

Vue.use(VeeValidate, veeValidateOptions);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(LoadScript);
Vue.use(VueLettering);

Vue.config.productionTip = false;

const source =
  window.location.hostname === "oz4x4.uk" ||
  window.location.hostname === "dev.oz4x4.uk"
    ? "oz4x4uk"
    : "oz4x4eu";

Vue.prototype.$source = source;

Vue.use(
  VueGtag,
  {
    config: { id: "UA-59723259-5" },
    bootstrap: false
  },
  router
);

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App)
}).$mount("#app");
